import * as React from "react";
import { View, Text, Image, TouchableOpacity, StyleSheet } from "react-native";
import Icon from "react-native-vector-icons/FontAwesome";

import { currentLanguage } from "../../translations/CurrentLanguage";
import translation from "../../translations/translation";
import LocalizedStrings from "react-native-localization";
import { pickImage } from "../../services/imagePicker";
import { showToastDanger } from "../../utils";
import { colors, radius } from "../../theme/modern";

let strings = new LocalizedStrings(translation);

export default class ItemImageInputComponent extends React.PureComponent {
  onChoose = () => {
    pickImage()
      .then(image => {
        if (image) {
          this.props.onChange(image);
        }
      })
      .catch(error => showToastDanger(error.message));
  };

  onRemove = () => this.props.onChange("");

  render() {
    strings.setLanguage(currentLanguage().companyLanguage);
    const { value } = this.props;

    return (
      <View style={styles.container}>
        <Text style={styles.label}>{strings.Photo}</Text>
        <View style={styles.row}>
          <View style={styles.preview}>
            {value ? (
              <Image
                resizeMode="cover"
                source={{ uri: value }}
                style={styles.image}
              />
            ) : (
              <Icon name="image" size={26} color={colors.textFaint} />
            )}
          </View>
          <View>
            <TouchableOpacity
              activeOpacity={0.8}
              style={styles.button}
              onPress={this.onChoose}
            >
              <Icon name="upload" size={14} color={colors.primary} />
              <Text style={styles.buttonText}>{strings.ChoosePhoto}</Text>
            </TouchableOpacity>
            {value ? (
              <TouchableOpacity
                activeOpacity={0.8}
                style={[styles.button, styles.remove]}
                onPress={this.onRemove}
              >
                <Icon name="trash-o" size={14} color={colors.danger} />
                <Text style={[styles.buttonText, styles.removeText]}>
                  {strings.RemovePhoto}
                </Text>
              </TouchableOpacity>
            ) : null}
          </View>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    marginTop: 15,
    paddingLeft: 10,
  },
  label: {
    marginBottom: 10,
    fontSize: 15,
    fontWeight: "bold",
    color: colors.text,
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
  },
  preview: {
    width: 132,
    height: 92,
    marginRight: 16,
    borderRadius: radius.medium,
    borderWidth: 1,
    borderColor: colors.border,
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    backgroundColor: "#f8fafc",
  },
  image: {
    width: 132,
    height: 92,
  },
  button: {
    height: 38,
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 14,
    marginVertical: 3,
    borderRadius: radius.small,
    backgroundColor: colors.primarySoft,
  },
  buttonText: {
    marginLeft: 8,
    fontSize: 14,
    fontWeight: "bold",
    color: colors.primary,
  },
  remove: {
    backgroundColor: colors.dangerSoft,
  },
  removeText: {
    color: colors.danger,
  },
});
